import { BrowserSpeechProvider } from "./browserSpeechProvider";
import type { SpeechInputProvider } from "./speech.types";

/**
 * The speech providers, in order of preference: the first that reports support is used. A server
 * model that streams audio would be added here; nothing outside this folder names a provider.
 */
const providers: SpeechInputProvider[] = [new BrowserSpeechProvider()];

/** The provider voice input uses, or the first one when none is supported (so the reason can be given). */
export const getSpeechProvider = (): SpeechInputProvider => providers.find((provider) => provider.isSupported()) ?? providers[0];

export const registerSpeechProvider = (provider: SpeechInputProvider): (() => void) => {
  providers.unshift(provider);
  return () => {
    const index = providers.indexOf(provider);
    if (index >= 0) providers.splice(index, 1);
  };
};
